// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fuzE93KTc4ZKNBYf3LAfy
// Component: 5RLoIE7-j5

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  SingleBooleanChoiceArg,
  StrictProps,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_plasmic_kit_color_tokens_css from "../plasmic_kit_q_4_color_tokens/plasmic_plasmic_kit_q_4_color_tokens.module.css"; // plasmic-import: 95xp9cYcv7HrNWpFWWhbcv/projectcss
import projectcss from "./plasmic_plasmic_kit_context_menu_indicator.module.css"; // plasmic-import: fuzE93KTc4ZKNBYf3LAfy/projectcss
import sty from "./PlasmicMenuIndicator.module.css"; // plasmic-import: 5RLoIE7-j5/css

import DownloadsvgIcon from "./icons/PlasmicIcon__Downloadsvg"; // plasmic-import: s7v30LEVvl/icon

createPlasmicElementProxy;

export type PlasmicMenuIndicator__VariantMembers = {
  interactive: "interactive";
  isRecording: "isRecording";
};
export type PlasmicMenuIndicator__VariantsArgs = {
  interactive?: SingleBooleanChoiceArg<"interactive">;
  isRecording?: SingleBooleanChoiceArg<"isRecording">;
};
type VariantPropType = keyof PlasmicMenuIndicator__VariantsArgs;
export const PlasmicMenuIndicator__VariantProps = new Array<VariantPropType>(
  "interactive",
  "isRecording"
);

export type PlasmicMenuIndicator__ArgsType = {};
type ArgPropType = keyof PlasmicMenuIndicator__ArgsType;
export const PlasmicMenuIndicator__ArgProps = new Array<ArgPropType>();

export type PlasmicMenuIndicator__OverridesType = {
  root?: p.Flex<"button">;
  dropSmoothCorners?: p.Flex<"div">;
  svg?: p.Flex<"svg">;
};

export interface DefaultMenuIndicatorProps {
  interactive?: SingleBooleanChoiceArg<"interactive">;
  isRecording?: SingleBooleanChoiceArg<"isRecording">;
  className?: string;
}

const $$ = {};

function PlasmicMenuIndicator__RenderFunc(props: {
  variants: PlasmicMenuIndicator__VariantsArgs;
  args: PlasmicMenuIndicator__ArgsType;
  overrides: PlasmicMenuIndicator__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "interactive",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.interactive,
      },
      {
        path: "isRecording",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isRecording,
      },
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs,
  });

  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_plasmic_kit_color_tokens_css.plasmic_tokens,
        sty.root,
        {
          [sty.rootinteractive]: hasVariant(
            $state,
            "interactive",
            "interactive"
          ),
        }
      )}
      tabIndex={-1}
    >
      <div
        data-plasmic-name={"dropSmoothCorners"}
        data-plasmic-override={overrides.dropSmoothCorners}
        className={classNames(projectcss.all, sty.dropSmoothCorners, {
          [sty.dropSmoothCornersinteractive]: hasVariant(
            $state,
            "interactive",
            "interactive"
          ),
          [sty.dropSmoothCornersisRecording]: hasVariant(
            $state,
            "isRecording",
            "isRecording"
          ),
        })}
      >
        <DownloadsvgIcon
          data-plasmic-name={"svg"}
          data-plasmic-override={overrides.svg}
          className={classNames(projectcss.all, sty.svg)}
          role={"img"}
        />
      </div>
    </button>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "dropSmoothCorners", "svg"],
  dropSmoothCorners: ["dropSmoothCorners", "svg"],
  svg: ["svg"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "button";
  dropSmoothCorners: "div";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicMenuIndicator__OverridesType,
  DescendantsType<T>
>;

type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicMenuIndicator__VariantsArgs;
    args?: PlasmicMenuIndicator__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicMenuIndicator__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicMenuIndicator__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicMenuIndicator__ArgProps,
          internalVariantPropNames: PlasmicMenuIndicator__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicMenuIndicator__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicMenuIndicator";
  } else {
    func.displayName = `PlasmicMenuIndicator.${nodeName}`;
  }
  return func;
}

export const PlasmicMenuIndicator = Object.assign(
  // Top-level PlasmicMenuIndicator renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    dropSmoothCorners: makeNodeComponent("dropSmoothCorners"),
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicMenuIndicator
    internalVariantProps: PlasmicMenuIndicator__VariantProps,
    internalArgProps: PlasmicMenuIndicator__ArgProps,
  }
);

export default PlasmicMenuIndicator;
/* prettier-ignore-end */
